import {
	GET_ALL_COLORS,
	SAVE_COLOR,
	DELETE_COLOR
} from '../../Actions/Admin/ManageColorAction';

const initialState = {
	colors: []
};
export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_ALL_COLORS:
			return {
				...state,
				loading: true,
				colors: action.payload
			};
		
		case SAVE_COLOR:
			return {
				...state,
				colors: action.payload
			};
		case DELETE_COLOR:
			return {
				...state,
				colors: action.payload
			};
		default:
			return state;
	}
};
